export enum ActivitiesSectionPageTypeEnum {
  Member = 'member',
  Customer = 'customer',
  Assignment = 'assignment',
  Worker = 'worker',
  Company = 'company',
}
